<template>
  <div>
    <FormSection title="Tickets">
      <div class="form-row">
        <div class="tickets-num">
          <input
            id="ticketsQnt"
            type="number"
            min="1"
            name="ticketsQnt"
            placeholder="Number of tickets"
            v-model="ticketsQnt"
            @change="customQnt = true"
          />
          <div class="ticket__desc">
            Cost is
            <span v-if="coupon == 'NCSY'">₪30</span>
            <span v-else-if="coupon == 'GAPYEAR'">₪40</span>
            <span v-else-if="coupon == 'OLIM'">₪35</span>
            <span v-else>₪50</span>
            per person
          </div>
        </div>
        <input
          class="coupon"
          type="text"
          name="coupon"
          placeholder="Coupon code"
          v-model="coupon"
          @change="form.custom.coupon = coupon"
        />
        <div class="mark">
          <span class="correct" v-if="coupon == 'NCSY' || coupon == 'GAPYEAR' || coupon == 'OLIM'">✓</span>
          <span class="nope" v-if="coupon !== 'NCSY' && coupon !== 'GAPYEAR' && coupon !== 'OLIM' && coupon">x</span>
        </div>
      </div>
    </FormSection>
    <FormSection title="">
        <FormRow>
          <FormLabel class="control-label">Seating Preference</FormLabel>
        </FormRow>
        <FormRow>
                      <FormSelect field="custom.seatingRequests" class="width-half" style="margin-right:10px;">
                        <option value="" disabled selected hidden>Choose Your Section</option>
                          <option value="Mens section">Mens section</option>
                          <option value="Womens section">Womens section</option>
                          <option value="Family section">Family section</option>
                      </FormSelect>                          
										</FormRow> 
                    <br>
                    <FormRow>
          <FormLabel class="control-label">Additional Notes </FormLabel>
        </FormRow>
        <FormRow>
          <FormInput type="textarea" field="custom.Notes" />
        </FormRow> 
    </FormSection>
    <!-- <FormSection title="VIP Tickets">
      <div class="">
        <div class="tickets-num">
          <input
            id="ticketsVIPQnt"
            type="number"
            min="1"
            name="ticketsVIPQnt"
            placeholder="Number of VIP tickets"
            v-model="ticketsVIPQnt"
            @change="customVIPQnt = true"
          />
        </div>
        <div class="ticket__desc">
          Cost is ₪200 per person <br />VIP tickets will include access to a VIP reception
          prior to the main event and priority seating in the front rows of the concert.
        </div>
      </div>
    </FormSection> -->
    <FormSection title="Would you like to add a donation to your order?">
      <div class="styled-radio styled-radio--ou-donation row">
        <div v-for="amount of amounts" :key="amount" class="radio-part">
          <input
            :id="`amount${amount}`"
            type="radio"
            class="amount"
            @click="selectedAmount = amount"
            :checked="selectedAmount == amount"
          />
          <FormLabel :for="`amount${amount}`">
            <MoneyFormat
              class="label-amount"
              :value="amount"
              :currencyCode="form.currency"
              :hide-subunits="true"
            />
          </FormLabel>
        </div>
        <div class="amount_other__wrapper amount-row">
          <input
            id="amount_other_check"
            type="radio"
            class="amount"
            :checked="customSelected"
            @click="customSelected = true"
          />
          <input
            id="amount_other"
            type="number"
            min="1"
            name="amount_other"
            placeholder="Other"
            v-model="customAmount"
          />
        </div>
      </div>
      <InHonorOf />

    </FormSection>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const ticketsQnt = ref();
    const ticketsVIPQnt = ref();
    const coupon = ref();
    const customAmount = ref();
    const customSelected = ref(false);
    const customQnt = ref(false);
    const customVIPQnt = ref(false);

    let ticketCost = 0;
    let ticketVIPCost = 0;
    let tempAmount = 0;

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        setValue("custom.donationAmount", selectedAmount);
        customSelected.value = false;
        customAmount.value = null;
        setValue("amount", "" + (selectedAmount + ticketCost + ticketVIPCost));
      }
    });
    watch(customQnt, () => {
      customQnt.value = false;
      if (coupon.value == "NCSY") ticketCost = 30 * ticketsQnt.value;
      else if (coupon.value == "GAPYEAR") ticketCost = 40 * ticketsQnt.value;
      else if (coupon.value == "OLIM") ticketCost = 35 * ticketsQnt.value;
      else ticketCost = 50 * ticketsQnt.value;

      if (ticketsQnt) {
        setValue("custom.ticketsQnt", ticketsQnt.value);
        if (customSelected.value) {
          setValue("amount", "" + (tempAmount + ticketCost + ticketVIPCost));
        } else {
          setValue(
            "amount",
            "" +
              (ticketCost +
                ticketVIPCost +
                (selectedAmount.value ? selectedAmount.value : 0))
          );
        }
      }
    });
    watch(customVIPQnt, () => {
      customVIPQnt.value = false;
      ticketVIPCost = 200 * ticketsVIPQnt.value;
      if (ticketsVIPQnt) {
        setValue("custom.ticketsVIPQnt", ticketsVIPQnt.value);
        if (customSelected.value) {
          setValue("amount", "" + (tempAmount + ticketCost + ticketVIPCost));
        } else {
          setValue(
            "amount",
            "" +
              (ticketCost +
                ticketVIPCost +
                (selectedAmount.value ? selectedAmount.value : 0))
          );
        }
      }
    });

    watch(coupon, () => {
      if (coupon.value == "NCSY") ticketCost = 30 * ticketsQnt.value;
      else if (coupon.value == "GAPYEAR") ticketCost = 40 * ticketsQnt.value;
      else if (coupon.value == "OLIM") ticketCost = 35 * ticketsQnt.value;
      else ticketCost = 50 * ticketsQnt.value;

      if (ticketsQnt) {
        setValue("custom.ticketsQnt", ticketsQnt.value);
        if (customSelected.value) {
          setValue("amount", "" + (tempAmount + ticketCost + ticketVIPCost));
        } else {
          setValue(
            "amount",
            "" +
              (ticketCost +
                ticketVIPCost +
                (selectedAmount.value ? selectedAmount.value : 0))
          );
        }
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      tempAmount = +customAmount;

      if (!selectedAmount.value) {
        setValue("custom.donationAmount", customAmount);
        setValue("amount", "" + (+customAmount + ticketCost + ticketVIPCost));
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts!;

      if (Array.isArray(amounts)) {
        return amounts;
      }

      return amounts[form.value.currency || "USD"];
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      ticketsVIPQnt,
      clearOutSelectedValue,
      customSelected,
      customQnt,
      customVIPQnt,
      coupon,
    };
  },
});
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation .amount_other__wrapper {
  position: relative;
  margin-bottom: 10px;
  margin-right: 0;
  min-width: 16.6%;
  max-width: 31.6%;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  line-height: 1;
  @media (max-width: 720px) {
    margin-right: 5px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  &:before {
    content: "$";
    position: absolute;
    padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #fff;
    top: 0px;
    left: 0;
  }
  &.USD:before {
    content: "$";
  }
  &.CAN:before {
    content: "C$";
  }
  &.ILS:before {
    content: "₪";
  }

  input[type="number"] {
    border: none;
    margin-left: 20px;
    box-shadow: none;
    width: calc(100% + 20px);
    font-size: 12px;
  }
  &:after {
    display: none !important;
  }
}
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type="number"] {
      background: #fff;
      margin-top: -15px !important;
    }
  }
}

.tickets-num {
  margin-bottom: 15px;
  width: 200px;
  label {
    margin-bottom: 5px;
  }
}
.ticket__desc {
  margin-top: 7px;
  font-style: italic;
  font-size: 14px;
  line-height: 1.4;
}

label.control-label {
  padding: 0px !important;
  display: flex !important;
  line-height: normal;
}
.form-row {
  display: flex;
  align-items: flex-start;
  .coupon {
    margin-left: 10px;
    max-width: 150px;
  }
}
.mark {
  margin-left: 10px;
  > span {
    display: flex;
    width: 18px;
    height: 18px;
    font-size: 12px;
    border-radius: 50%;
    color: white;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    &.correct {
      background: #00a500;
    }
    &.nope {
      background: #bd0000;
      font-weight: bold;
      padding-bottom: 1px;
    }
  }
}
.note {
  margin-top: 15px;
  background: #348dff1a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #d8e2ec;
  line-height: 1.4;
}
</style>
